export const csrdRoutePaths = {
  HOME: '/csrd',
  CHECKOUT: '/csrd/checkout',
  SUBSCRIPTION_CHECKOUT: '/csrd/subscription-checkout',
  SUBSCRIPTION_CONFIRMATION: '/csrd/subscription-checkout/confirmation/:orderId',
  CONFIRMATION: '/csrd/checkout/confirmation/:orderId',
  PRICING: '/csrd/pricing',
  ABOUT: '/csrd/about',
  ABOUT_CSRD_AND_REPORTING_STANDARDS: '/csrd/about/csrd-and-reporting-standards',
  ABOUT_METHODOLOGY_AND_TRACEABILITY: '/csrd/about/methodology-and-traceability',
  ABOUT_REPORTING_STANDARDS: '/csrd/about/reporting-standards',
  ABOUT_CSRD: '/csrd/about/csrd',
  ABOUT_STENAS_OFFER: '/csrd/about/stenas-offer',
  MY_REPORTS: '/csrd/my-reports',
  OVERVIEW: '/csrd/overview',
} as const;

// Navigation state set by the main menu to signal that CSRD should open on the user's last sub-page
export const csrdRestoreLastSubpageState = { restoreLastSubpage: true } as const;

export const isCsrdRestoreLastSubpageRequested = (state: unknown): boolean =>
  typeof state === 'object' &&
  state !== null &&
  'restoreLastSubpage' in state &&
  state.restoreLastSubpage === true;
